import { Modal, ModalWithTransition } from '@studiometa/ui';

/**
 * Panel Class.
 */
export default class LanguageModal extends ModalWithTransition {
  isOpen = false;

  static config = {
    name: 'LanguageModal',
    refs: [...Modal.config.refs, 'languages', 'loader', 'select[]', 'form'],
    options: {
      styles: {
        type: Object,
        /**
         * @returns {ModalStylesOption}
         */
        default: () => ({
          modal: {
            closed: {
              opacity: '0',
              pointerEvents: 'none',
            },
            open: {
              opacity: '1',
              pointerEvents: 'auto',
            },
          },
          overlay: {
            closed: 'opacity-0',
          },
          container: {
            closed: 'translate-y-20 opacity-0',
          },
        }),
      },
    },
  };

  /**
   *
   */
  mounted() {
    if (this.$refs.select.length > 0) {
      this.languages = this.$refs.select[1];
    }

    super.mounted();
  }

  /**
   * Handle select item click
   * @param {object} props
   * @param {number} props.index Current index element.
   */
  onSelectChange({ index }) {
    if (this.$refs.form && index === 0) {
      this.$refs.loader.classList.remove('opacity-0');
      const formData = new FormData(this.$refs.form);

      fetch(this.$refs.form.action, {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.text();
        })
        .then((html) => {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;
          const languagesElement = tempDiv.querySelector('#languages');

          if (languagesElement && this.languages) {
            this.$refs.languages.innerHTML = languagesElement.innerHTML;
          } else {
            console.warn(
              'Élément #languages non trouvé dans la réponse ou référence languages manquante',
            );
          }

          this.$update();
        })
        .catch((error) => {
          console.error('Erreur lors du fetch:', error);
        });
    }
  }
}
